import FrontendDeveloperPage from "./FrontendDeveloperPage";

export default function JavaScriptDeveloperPage() {
  return <FrontendDeveloperPage technology="javascript" />;
}
